import ModalCloseIcon from "@/components/icons/modal-close-icon";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import useAuth from "@/hooks/use-auth";

import DragonBg from "./dragon-bg";

function SignupContent() {
  const { login, signup } = useAuth();

  return (
    <div className="flex flex-col gap-4">
      <h6 className="text-center font-semibold text-16/[1.5em] text-white">
        Sign up for Morty
      </h6>
      <p className="text-14/[1.5em] text-white">
        Wishlist attractions, track and review your experiences, and connect
        with the others.
      </p>
      <Button
        className="h-[50px] w-full rounded-[25px] text-16"
        onClick={signup}
        variant="cta"
      >
        Sign up
      </Button>
      <Button
        className="h-[30px] w-full font-medium text-14 text-white"
        onClick={login}
      >
        Existing user? <span className="underline">Log in</span>
      </Button>
    </div>
  );
}

interface SignupModalProps extends React.ComponentProps<typeof Dialog> {}

export default function SignupModal({
  children = <SignupContent />,
  ...props
}: SignupModalProps) {
  return (
    <Dialog {...props}>
      <DialogContent
        className="flex min-h-full flex-col gap-0 border-0 bg-[url(/images/main-bg.jpg)] bg-cover bg-top bg-no-repeat p-0 md:min-h-auto md:w-85 md:rounded-[25px]"
        overlayClassName="bg-black/50 items-center md:items-center"
      >
        <DialogTitle className="sr-only">Sign up for Morty</DialogTitle>
        <Button
          aria-label="Close"
          className="group absolute top-5 left-6 flex size-[25px] rounded-full border border-white hover:bg-white"
          onClick={() => props.onOpenChange?.(false)}
        >
          <ModalCloseIcon className="transition-colors group-hover:text-dark-magenta" />
        </Button>
        <div className="-mb-[55px]">
          <DragonBg />
        </div>
        <div className="p-6">{children}</div>
      </DialogContent>
    </Dialog>
  );
}
